import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import global from '../../../common/utility/global';
import CustomTable from '../../../components/CustomTable';
import auth from "../../../common/utility/auth";

const REGISTRADO = 1;
const ENVIADO = 2;
const ANULADO = 3;
const IMPORTADO = 4;
export default function ResultList(props) {
    const renderColor = (row) => {
        if (row.idCompraEstado === REGISTRADO)
            return 'blue';
        if (row.idCompraEstado === ENVIADO)
            return 'green';
        if (row.idCompraEstado === ANULADO)
            return 'red';
        if (row.idCompraEstado === IMPORTADO)
            return 'orange';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingVer}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>


                            <Tooltip placement="top" title="Anular">
                                {row.tipoComprobante == "07" ?
                                    <Button
                                        type="danger"
                                        icon="close"
                                        size={"small"}
                                        loading={props.loadingVincular}
                                        disabled={(row.idCompraEstado == ENVIADO || row.idCompraEstado == ANULADO) ? true : false}
                                        onClick={() => props.onAnular(row)}
                                    /> :

                                    <Button
                                        type="danger"
                                        icon="close"
                                        size={"small"}
                                        disabled={(row.idCompraEstado == REGISTRADO || row.idCompraEstado == ENVIADO) ? false : true}
                                        onClick={() => props.onAnular(row)}
                                    />
                                }
                            </Tooltip>

                            <Tooltip placement="top" title="Aprobar">
                                <Button
                                    type="success"
                                    icon="check"
                                    size={"small"}
                                    disabled={row.idCompraEstado === REGISTRADO ? false : true}
                                    onClick={() => props.onAprobar(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    disabled={row.idCompraEstado === REGISTRADO ? false : true}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Vincular">
                                {row.tipoComprobante == "09" ?
                                    <Button
                                        type="success"
                                        icon="api"
                                        size={"small"}
                                        loading={props.loadingVincular}
                                        disabled={(row.idCompraEstado === ENVIADO && row.idCompraVinculo == 0) ? false : true}
                                        onClick={() => props.onVincular(row)}
                                    /> :

                                    <Button
                                        type="success"
                                        icon="api"
                                        size={"small"}
                                        disabled={true}
                                    />
                                }
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Tipo Comprobante',
                    dataIndex: 'nombreTipoComprobante',
                    key: 'nombreTipoComprobante',
                    sorter: true
                },
                {
                    title: 'Tipo',
                    dataIndex: 'idTipoActividad',
                    key: 'idTipoActividad',
                    sorter: true,

                },
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Fecha Emisión',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Fecha Vencimiento',
                    dataIndex: 'fechaVencimientoStr',
                    key: 'fechaVencimientoStr',
                    sorter: true
                },
                {
                    title: 'Fecha Registro',
                    dataIndex: 'fechaDocumentoStr',
                    key: 'fechaDocumentoStr',
                    sorter: true
                },
                {
                    title: 'Fecha Recepción',
                    dataIndex: 'fechaRecepcionStr',
                    key: 'fechaRecepcionStr',
                    sorter: true
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'nombreTipoDocumentoProveedor',
                    key: 'nombreTipoDocumentoProveedor',
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumentoProveedor',
                    key: 'numeroDocumentoProveedor',
                    sorter: true
                },
                {
                    title: 'Razón Social',
                    dataIndex: 'razonSocialProveedor',
                    key: 'razonSocialProveedor',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Documento Vinculado',
                    dataIndex: 'documentoVinculo',
                    key: 'documentoVinculo',
                    sorter: true
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Sub Total',
                    dataIndex: 'subTotal',
                    key: 'subTotal',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Igv',
                    dataIndex: 'igv',
                    key: 'igv',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Total',
                    dataIndex: 'total',
                    key: 'total',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreCompraEstado',
                    key: 'nombreCompraEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}